//#region src/modules/ServicePeriods/activity-evals/constants.ts
var DATA_TYPE_LABELS = {
	"checkpoint-scan": "Checkpoint scan",
	"checkpoint-tour": "Checkpoint tour",
	event: "Event",
	"location-log-entry": "Location log entry",
	"patrol-visit": "Patrol visit",
	"shift-start": "Shift start",
	"user-geo-fence-arrival": "Geo-fence arrival",
	"user-geo-fence-departure": "Geo-fence departure",
	"user-gps-breadcrumb": "GPS breadcrumb"
};
var OCCURRENCE_TYPE_LABELS = {
	cadence: "Cadence",
	continuous: "Continuous",
	count: "Count"
};
//#endregion
export { DATA_TYPE_LABELS, OCCURRENCE_TYPE_LABELS };

//# sourceMappingURL=constants.js.map